import { Box, Button, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FationImage from "../assets/images/fashion.webp";
const SubHeader = styled((props) => (
  <Typography variant="h6" {...props}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "lato",
  letterSpacing: 2,
  fontWeight: 400,
  color: "white",
  textAlign: "center",
  textTransform: "uppercase",
  wordSpacing: 3,
}));
const MainHeader = styled((props) => (
  <Typography {...props}>{props.children}</Typography>
))(({ theme }) => ({
  fontFamily: "lato",
  letterSpacing: 2,
  fontWeight: 800,
  color: "white",
  textAlign: "center",
  textTransform: "uppercase",
  wordSpacing: 3,
  lineHeight: 2,
  "& span": {
    color: "#b59677",
  },
  [theme.breakpoints.up("xs")]: {
    fontSize: "30px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "40px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "50px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "60px",
  },
}));
const StyledButton = styled((props) => (
  <Button variant="outlined" {...props}>
    {props.children}
  </Button>
))(({ theme }) => ({
  fontFamily: "lato",
  color: "white",
  textAlign: "center",
  textTransform: "uppercase",
  border: "1px solid white",
  height: "3rem",
  padding: "14px",

  "&:hover": {
    background: "#b59677",
    border: "none",
  },
}));

const BgWrapper = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    height: "500px",
    overflow: "hidden",
    position: "relative",
    overflowX: "hidden",
    perspective: "2px",
  })
);
const BgBox = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme, hover }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundRepeat: "no-repeat",
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    backgroundSize: "cover",
    backgroundImage: `url(${FationImage})`,
    zIndex: -1,
    backgroundAttachment: "fixed",
  })
);

const FashionSection = () => {
  const [hover, setHover] = useState(0);
  const HandleScroll = () => {
    setHover(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", HandleScroll);
    return () => {
      window.removeEventListener("scroll", HandleScroll);
    };
  }, []);
  return (
    // <BgWrapper sx={{ my:8,height:'500px'}}>
    // <Box sx={{position:'absolute',zI backgroundImage:`url(${FationImage})`,backgroundSize:'cover',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',backgroundRepeat: 'no-repeat'}}>
    //      <Box sx={{ display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center' }}>
    //      <SubHeader>my name's gecko</SubHeader>
    //      <MainHeader><span>The best</span> shopify theme</MainHeader>
    //      <StyledButton>purchase now</StyledButton>
    //      </Box>
    // </Box>
    // </BgWrapper>
    <BgWrapper>
      <BgBox hover={hover}>
        <SubHeader>my name's gecko</SubHeader>
        <MainHeader>
          <span>The best</span> shopify theme
        </MainHeader>
        <StyledButton>purchase now</StyledButton>
      </BgBox>
    </BgWrapper>
  );
};

export default FashionSection;
